import {Component} from '@angular/core';
import {PermissionService} from "../../../_auth/permission.service";
import {AppRoutes} from "../../../enums/routes";
import {CompanyRoutes} from "../x-models/x-enums/company-routes";
import {
  NavbarItemLargeComponent
} from "../../../x-components/navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../../../x-components/navbar-base/navbar-container/navbar-container.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-navbar-company',
  templateUrl: './navbar-company.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-company.component.scss']
})
export class NavbarCompanyComponent {
  protected readonly Router = AppRoutes;
  protected readonly CompanyRoutes = CompanyRoutes;
  protected readonly Routes = AppRoutes;

  constructor(public PermissionService: PermissionService) {
  }
}
